var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homePage"},[_c('router-view',{staticStyle:{"padding-left":"180px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }